import { useRouter } from "next/router";
import React from "react";

import FormattedMessage from "@components/UI/FormattedMessage";
import Link from "@components/UI/Link";

export default function ResultLogin() {
  const router = useRouter();

  return (
    <div>
      <h3 className="h3 result-h3">
        <FormattedMessage id="ResultLogin.title" />
      </h3>
      <div className="result-box">
        <Link
          href={{
            pathname: "/login",
            query: { redirectAfterLogin: router.asPath },
          }}
        >
          <a className="link pointer noselect change-ticket" role="button">
            <FormattedMessage id="ResultLogin.link" />
          </a>
        </Link>
      </div>
    </div>
  );
}
